import {configureStore} from '@reduxjs/toolkit';
import {setupListeners} from '@reduxjs/toolkit/query';
import {type TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux';
import {authApi} from 'src/redux/api/authApi';
import usuarioReducer from 'src/redux/features/usuarioSlice';
import rtkQueryErrorLogger from 'src/redux/features/ErrorMiddleware';
import breadcrumbReducer from './features/breadcrumbSlice';
import {usuariosApi} from './api/usuariosApi';
import { unidadesAcademicasApi } from './api/unidadesAcademicasApi';
import { maestrosApi } from './api/maestrosApi';
import { proyectosApi } from './api/proyectosApi';
import { documentosSoporteApi } from './api/documentosSoporteApi';
import { productosApi } from './api/productosApi';
import { actividadesApi } from './api/actividadesApi';
import { auditoriaApi } from './api/auditoriaApi';
import { aspirantesApi } from './api/aspirantesApi';

/**
 * Abstraccion de los estados de la aplicacion
 *
 * @see https://redux-toolkit.js.org/api/configureStore
 * @see https://redux-toolkit.js.org/api/getDefaultMiddleware
 *
 * Reducers
 * @see https://redux-toolkit.js.org/api/createReducer
 *
 * DevTools
 * @see https://redux-toolkit.js.org/api/getDefaultMiddleware#included-default-middleware
 */
export const store = configureStore({
	reducer: {
		[authApi.reducerPath]: authApi.reducer,
		[usuariosApi.reducerPath]: usuariosApi.reducer,
		[unidadesAcademicasApi.reducerPath]: unidadesAcademicasApi.reducer,
		[maestrosApi.reducerPath]: maestrosApi.reducer,
		[proyectosApi.reducerPath]: proyectosApi.reducer,
		[documentosSoporteApi.reducerPath]: documentosSoporteApi.reducer,
		[productosApi.reducerPath]: productosApi.reducer,
		[actividadesApi.reducerPath]: actividadesApi.reducer,
		[auditoriaApi.reducerPath]: auditoriaApi.reducer,
		[aspirantesApi.reducerPath]: aspirantesApi.reducer,
		usuario: usuarioReducer,
		breadcrumbs: breadcrumbReducer,
	},
	devTools: process.env.NODE_ENV === 'development',
	middleware: (getDefaultMiddleware) => getDefaultMiddleware({
		serializableCheck: false,
	}).concat(
		authApi.middleware,
		usuariosApi.middleware,
		unidadesAcademicasApi.middleware,
		maestrosApi.middleware,
		proyectosApi.middleware,
		documentosSoporteApi.middleware,
		productosApi.middleware,
		actividadesApi.middleware,
		auditoriaApi.middleware,
		aspirantesApi.middleware,
		rtkQueryErrorLogger,
	),
});

setupListeners(store.dispatch);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
